import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, vModelSelect as _vModelSelect, Transition as _Transition, unref as _unref, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "project-workspace" }
const _hoisted_2 = { class: "workspace-header" }
const _hoisted_3 = { class: "header-content" }
const _hoisted_4 = { class: "header-left" }
const _hoisted_5 = { class: "workspace-subtitle" }
const _hoisted_6 = {
  key: 0,
  class: "dropdown-content"
}
const _hoisted_7 = { class: "stats-grid" }
const _hoisted_8 = { class: "stat-content" }
const _hoisted_9 = { class: "stat-value" }
const _hoisted_10 = { class: "stat-label" }
const _hoisted_11 = { class: "stat-sublabel" }
const _hoisted_12 = { class: "stat-content" }
const _hoisted_13 = { class: "stat-value" }
const _hoisted_14 = { class: "stat-label" }
const _hoisted_15 = { class: "stat-sublabel" }
const _hoisted_16 = { class: "stat-content" }
const _hoisted_17 = { class: "stat-value" }
const _hoisted_18 = { class: "stat-label" }
const _hoisted_19 = { class: "stat-sublabel" }
const _hoisted_20 = {
  key: 1,
  class: "stat-card"
}
const _hoisted_21 = { class: "stat-content" }
const _hoisted_22 = { class: "stat-value" }
const _hoisted_23 = { class: "stat-label" }
const _hoisted_24 = { class: "stat-sublabel" }
const _hoisted_25 = { class: "workspace-body" }
const _hoisted_26 = { class: "tabs-navigation" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = ["innerHTML"]
const _hoisted_29 = { class: "tab-label" }
const _hoisted_30 = {
  key: 0,
  class: "tab-badge"
}
const _hoisted_31 = {
  key: 0,
  class: "filter-panel"
}
const _hoisted_32 = { class: "filter-panel-header" }
const _hoisted_33 = { class: "filter-grid" }
const _hoisted_34 = { class: "filter-group" }
const _hoisted_35 = { class: "filter-label" }
const _hoisted_36 = { class: "filter-options" }
const _hoisted_37 = { class: "checkbox-label" }
const _hoisted_38 = ["checked"]
const _hoisted_39 = { class: "checkbox-label" }
const _hoisted_40 = ["checked"]
const _hoisted_41 = { class: "checkbox-label" }
const _hoisted_42 = ["checked"]
const _hoisted_43 = { class: "checkbox-label" }
const _hoisted_44 = ["checked"]
const _hoisted_45 = { class: "filter-group" }
const _hoisted_46 = { class: "filter-label" }
const _hoisted_47 = { class: "date-range-inputs" }
const _hoisted_48 = ["placeholder"]
const _hoisted_49 = { class: "range-separator" }
const _hoisted_50 = ["placeholder"]
const _hoisted_51 = {
  key: 0,
  class: "filter-group"
}
const _hoisted_52 = { class: "filter-label" }
const _hoisted_53 = { class: "budget-range-inputs" }
const _hoisted_54 = ["placeholder"]
const _hoisted_55 = { class: "range-separator" }
const _hoisted_56 = ["placeholder"]
const _hoisted_57 = {
  key: 1,
  class: "filter-group"
}
const _hoisted_58 = { class: "filter-label" }
const _hoisted_59 = { class: "filter-options" }
const _hoisted_60 = { class: "checkbox-label" }
const _hoisted_61 = { class: "checkbox-label" }
const _hoisted_62 = {
  key: 2,
  class: "filter-group"
}
const _hoisted_63 = { class: "filter-label" }
const _hoisted_64 = { value: null }
const _hoisted_65 = ["value"]
const _hoisted_66 = {
  key: 3,
  class: "filter-group"
}
const _hoisted_67 = { class: "filter-label" }
const _hoisted_68 = { value: null }
const _hoisted_69 = ["value"]
const _hoisted_70 = { class: "tab-content" }
const _hoisted_71 = {
  key: 0,
  class: "loading-state"
}
const _hoisted_72 = { key: 1 }
const _hoisted_73 = { key: 2 }
const _hoisted_74 = { key: 3 }
const _hoisted_75 = {
  key: 4,
  class: "overview-dashboard"
}
const _hoisted_76 = { class: "alerts-panel" }
const _hoisted_77 = { class: "section-title" }
const _hoisted_78 = {
  key: 0,
  class: "alerts-list"
}
const _hoisted_79 = { class: "alert-text" }
const _hoisted_80 = { class: "alert-text" }
const _hoisted_81 = { class: "alert-text" }
const _hoisted_82 = {
  key: 1,
  class: "no-alerts"
}
const _hoisted_83 = { class: "deadlines-grid" }
const _hoisted_84 = { class: "deadline-section" }
const _hoisted_85 = { class: "section-title" }
const _hoisted_86 = {
  key: 0,
  class: "deadline-list"
}
const _hoisted_87 = ["onClick"]
const _hoisted_88 = { class: "deadline-content" }
const _hoisted_89 = { class: "deadline-name" }
const _hoisted_90 = { class: "deadline-date" }
const _hoisted_91 = { class: "days-badge days-upcoming" }
const _hoisted_92 = {
  key: 1,
  class: "empty-state-small"
}
const _hoisted_93 = { class: "deadline-section" }
const _hoisted_94 = { class: "section-title" }
const _hoisted_95 = {
  key: 0,
  class: "deadline-list"
}
const _hoisted_96 = ["onClick"]
const _hoisted_97 = { class: "deadline-content" }
const _hoisted_98 = { class: "deadline-name" }
const _hoisted_99 = { class: "deadline-date" }
const _hoisted_100 = { class: "days-badge days-overdue" }
const _hoisted_101 = {
  key: 1,
  class: "empty-state-small"
}
const _hoisted_102 = {
  key: 0,
  class: "budget-overview-card"
}
const _hoisted_103 = { class: "section-title" }
const _hoisted_104 = { class: "budget-main" }
const _hoisted_105 = { class: "budget-progress" }
const _hoisted_106 = { class: "budget-bar" }
const _hoisted_107 = { class: "budget-info" }
const _hoisted_108 = { class: "budget-percentage" }
const _hoisted_109 = { class: "budget-amount-text" }
const _hoisted_110 = {
  key: 0,
  class: "budget-breakdown"
}
const _hoisted_111 = { class: "breakdown-title" }
const _hoisted_112 = { class: "breakdown-list" }
const _hoisted_113 = ["onClick"]
const _hoisted_114 = { class: "breakdown-label" }
const _hoisted_115 = { class: "breakdown-value" }
const _hoisted_116 = {
  key: 1,
  class: "empty-state-small"
}
const _hoisted_117 = { class: "bottom-grid" }
const _hoisted_118 = { class: "intervenants-card" }
const _hoisted_119 = { class: "section-title" }
const _hoisted_120 = {
  key: 0,
  class: "intervenants-list"
}
const _hoisted_121 = ["onClick"]
const _hoisted_122 = { class: "intervenant-info" }
const _hoisted_123 = { class: "intervenant-name" }
const _hoisted_124 = { class: "intervenant-tasks" }
const _hoisted_125 = {
  key: 1,
  class: "empty-state-small"
}
const _hoisted_126 = { class: "status-card" }
const _hoisted_127 = { class: "section-title" }
const _hoisted_128 = { class: "status-list" }
const _hoisted_129 = { class: "status-label" }
const _hoisted_130 = { class: "status-count" }
const _hoisted_131 = { class: "status-label" }
const _hoisted_132 = { class: "status-count" }
const _hoisted_133 = { class: "status-label" }
const _hoisted_134 = { class: "status-count" }
const _hoisted_135 = { class: "status-label" }
const _hoisted_136 = { class: "status-count" }
const _hoisted_137 = { class: "details-panel" }
const _hoisted_138 = { class: "panel-header" }
const _hoisted_139 = ["title"]
const _hoisted_140 = { class: "panel-content" }
const _hoisted_141 = {
  key: 0,
  class: "detail-content"
}
const _hoisted_142 = { class: "detail-grid" }
const _hoisted_143 = { class: "detail-item" }
const _hoisted_144 = { class: "detail-label" }
const _hoisted_145 = { class: "detail-item detail-item-full" }
const _hoisted_146 = { class: "detail-label" }
const _hoisted_147 = { class: "detail-value" }
const _hoisted_148 = {
  key: 0,
  class: "detail-item detail-item-full"
}
const _hoisted_149 = { class: "detail-label" }
const _hoisted_150 = { class: "detail-value" }
const _hoisted_151 = { class: "detail-item detail-item-full" }
const _hoisted_152 = { class: "detail-label" }
const _hoisted_153 = { class: "task-list" }
const _hoisted_154 = {
  key: 0,
  class: "no-tasks"
}
const _hoisted_155 = {
  key: 1,
  class: "detail-content"
}
const _hoisted_156 = { class: "intervenant-header" }
const _hoisted_157 = { class: "detail-grid" }
const _hoisted_158 = { class: "detail-item" }
const _hoisted_159 = { class: "detail-label" }
const _hoisted_160 = { class: "type-badge" }
const _hoisted_161 = { class: "detail-item detail-item-full" }
const _hoisted_162 = { class: "detail-label" }
const _hoisted_163 = ["href"]
const _hoisted_164 = { class: "detail-item detail-item-full" }
const _hoisted_165 = { class: "detail-label" }
const _hoisted_166 = ["href"]
const _hoisted_167 = {
  key: 0,
  class: "detail-item detail-item-full"
}
const _hoisted_168 = { class: "detail-label" }
const _hoisted_169 = { class: "detail-value" }
const _hoisted_170 = { class: "detail-item detail-item-full" }
const _hoisted_171 = { class: "detail-label" }
const _hoisted_172 = { class: "task-list" }
const _hoisted_173 = {
  key: 0,
  class: "no-tasks"
}
const _hoisted_174 = {
  key: 2,
  class: "detail-content"
}
const _hoisted_175 = { class: "detail-grid" }
const _hoisted_176 = { class: "detail-item" }
const _hoisted_177 = { class: "detail-label" }
const _hoisted_178 = { class: "detail-item" }
const _hoisted_179 = { class: "detail-label" }
const _hoisted_180 = { class: "amount-value" }
const _hoisted_181 = {
  key: 0,
  class: "detail-item"
}
const _hoisted_182 = { class: "detail-label" }
const _hoisted_183 = { class: "detail-value" }
const _hoisted_184 = {
  key: 1,
  class: "detail-item"
}
const _hoisted_185 = { class: "detail-label" }
const _hoisted_186 = { class: "detail-value" }
const _hoisted_187 = { class: "detail-item detail-item-full" }
const _hoisted_188 = { class: "detail-label" }
const _hoisted_189 = { class: "detail-value" }
const _hoisted_190 = {
  key: 2,
  class: "detail-item detail-item-full"
}
const _hoisted_191 = { class: "detail-label" }
const _hoisted_192 = { class: "detail-value" }

import { ref, computed, onMounted, watch, onBeforeUnmount } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import { useNotifications } from '@/composables/useNotifications'
import { usePermissions } from '@/composables/usePermissions'
import { useAuthStore } from '@/stores'
import PermissionGuard from '@/components/common/PermissionGuard.vue'
import PhaseFormModal from './modals/PhaseFormModal.vue'
import AssignIntervenantModal from './modals/AssignIntervenantModal.vue'
import TaskFormModal from './modals/TaskFormModal.vue'
import ConfirmModal from '@/components/common/ConfirmModal.vue'
import WorkspaceTasksTab from './shared/WorkspaceTasksTab.vue'
import WorkspaceIntervenantsTab from './shared/WorkspaceIntervenantsTab.vue'
import WorkspacePhasesTab from './shared/WorkspacePhasesTab.vue'
import projectPhasesService from '@/services/projectPhases.service'
import intervenantsService from '@/services/intervenants.service'
import projectTasksService from '@/services/projectTasks.service'
import reportService from '@/services/report.service.index'
import projectService from '@/services/project.service'
import { formatCurrencyWithUserPreference } from '@/utils/currencyUtils'
import { formatDate } from '@/utils/formatters'
import { getAvatarColor, getInitials, getProgressClass } from '@/utils/uiHelpers'
import { useProjectPhases } from '@/composables/useProjectPhases'
import type { BudgetConsumptionReport } from '@/types/services'

// Project interface
interface Project {
  id: number
  name: string
  multiPhase?: boolean
}

// Phase interface (based on PhaseDto from backend)
interface Phase {
  id?: number
  projectId: number
  name: string
  description?: string
  plannedStartDate?: string
  plannedEndDate?: string
  actualStartDate?: string
  actualEndDate?: string
  dependencyPhaseId?: number
  dependencyPhaseName?: string
  status: 'NOT_STARTED' | 'IN_PROGRESS' | 'ON_HOLD' | 'COMPLETED' | 'CANCELLED'
  isDelivered?: boolean
  deliveredDate?: string
  createdBy?: number
  createdAt?: string
  updatedAt?: string
}

// Intervenant interface (based on IntervenantDto from backend)
interface Intervenant {
  id?: number
  projectId?: number
  name: string
  type?: 'ARCHITECT' | 'STRUCTURAL_ENGINEER' | 'ELECTRICAL_ENGINEER' | 'PLUMBING_ENGINEER' | 
        'MECHANICAL_ENGINEER' | 'CONTRACTOR' | 'SUBCONTRACTOR' | 'SUPPLIER' | 'CONSULTANT' | 
        'SUPERVISOR' | 'INSPECTOR' | 'PROJECT_MANAGER' | 'SITE_MANAGER' | 'FOREMAN' | 
        'TECHNICIAN' | 'WORKER' | 'OTHER'
  email: string
  phone?: string
  address?: string
  createdAt?: string
  updatedAt?: string
}

// Task interface (based on TaskDto from backend)
interface Task {
  id?: number
  projectId?: number
  name: string
  description?: string
  amount: number
  startDate?: string
  endDate?: string
  status?: 'PENDING' | 'IN_PROGRESS' | 'COMPLETED' | 'CANCELLED' | 'ON_HOLD'
  assignedTo?: string
  createdBy?: number
  updatedBy?: number
  createdAt?: string
  updatedAt?: string
  intervenantName?: string
  intervenantId?: number
  phaseId?: number
  phaseName?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectWorkspace',
  props: {
    projectId: {},
    initialProject: {},
    defaultActiveTab: {}
  },
  setup(__props: any) {

// @ts-ignore
const { t } = useI18n()
const router = useRouter()
const { notifySuccess, notifyError } = useNotifications()
const { hasPermissionForProject, hasAnyPermissionForProject, PermissionType } = usePermissions()
const authStore = useAuthStore()

// Detect if the current user is a CLIENT
const isClientUser = computed(() => authStore.user?.type === 'CLIENT')

// Hide budget stat card and skip budget API call for clients in FULL_MANAGEMENT projects
const hideBudgetFromClient = computed(() =>
  isClientUser.value && project.value?.managementType === 'FULL_MANAGEMENT'
)

const props = __props

// State
const loading = ref(false)
const activeTab = ref(props.defaultActiveTab || 'phases')
const searchQuery = ref('')

// Initialize default tab based on project type and permissions
const initializeDefaultTab = () => {
  // If no explicit default tab is set, determine based on project type and permissions
  if (!props.defaultActiveTab) {
    if (project.value && !project.value.multiPhase) {
      // For non-multi-phase projects, prioritize intervenants if accessible
      if (canAccessIntervenants.value) {
        activeTab.value = 'intervenants'
      } else if (canAccessTasks.value) {
        activeTab.value = 'tasks'
      } else {
        activeTab.value = 'overview'
      }
    } else {
      // For multi-phase projects, prioritize phases if accessible
      if (canAccessPhases.value) {
        activeTab.value = 'phases'
      } else if (canAccessIntervenants.value) {
        activeTab.value = 'intervenants'
      } else if (canAccessTasks.value) {
        activeTab.value = 'tasks'
      } else {
        activeTab.value = 'overview'
      }
    }
  } else {
    // Check if the provided default tab is accessible, otherwise fallback
    const requestedTab = props.defaultActiveTab
    const availableTabIds = tabs.value.map((tab: any) => tab.id)
    
    if (availableTabIds.includes(requestedTab)) {
      activeTab.value = requestedTab
    } else {
      // Fallback to first available tab
      activeTab.value = availableTabIds[0] || 'overview'
    }
  }
}

// Data
const project = ref<Project | null>(props.initialProject || null)
const phases = ref<Phase[]>([])
const intervenants = ref<Intervenant[]>([])
const tasks = ref<Task[]>([])
const budgetReport = ref<BudgetConsumptionReport | null>(null)

// Initialize project phases composable for multi-phase calculations
const {
  getPhaseTasks,
  getPhaseProgress,
  getPhaseBudget,
  getPhaseIntervenants,
  getActiveIntervenantsCount,
  getTotalBudget,
  getTasksForIntervenant
} = useProjectPhases(tasks, intervenants)

// Selection
const selectedPhase = ref<Phase | null>(null)
const selectedIntervenant = ref<Intervenant | null>(null)
const selectedTask = ref<Task | null>(null)

// Modals
const showPhaseModal = ref(false)
const showIntervenantModal = ref(false)
const showTaskModal = ref(false)
const showDeletePhaseConfirm = ref(false)
const editingPhase = ref<Phase | null>(null)
const editingTask = ref<Task | null>(null)
const deletePhaseId = ref<number | null>(null)
const deletePhaseMessage = ref('')

// UI State
const showQuickAdd = ref(false)
const showFilters = ref(false)
const quickAddDropdown = ref<HTMLElement | null>(null)

// Pagination State
const currentPage = ref(1)
const itemsPerPage = ref(10)
const itemsPerPageOptions = [5, 10, 25, 50, 100]

// Filter State
const filters = ref({
  status: [] as string[],
  dateRange: {
    start: '',
    end: ''
  },
  budgetRange: {
    min: 0,
    max: 0
  },
  assignment: {
    assigned: true,
    unassigned: true
  },
  phaseId: null as number | null,
  intervenantId: null as number | null
})

// Tabs Configuration
const tabs = computed(() => {
  const allTabs = []

  // In FULL_MANAGEMENT projects, clients must not see the intervenants tab
  // (it exposes cost details per intervenant which are opaque to the client)
  const isFullManagement = (project.value as any)?.managementType === 'FULL_MANAGEMENT'
  const hideIntervenantsFromClient = isClientUser.value && isFullManagement
  
  // Phases tab - only for multi-phase projects and users with phase access
  if (project.value?.multiPhase && canAccessPhases.value) {
    allTabs.push({
      id: 'phases',
      label: t('workspace.tabs.phases'),
      icon: '📊',
      count: phases.value.length
    })
  }
  
  // Intervenants tab - only for users with intervenants access
  // Hidden from clients in FULL_MANAGEMENT projects (cost details are opaque)
  if (canAccessIntervenants.value && !hideIntervenantsFromClient) {
    allTabs.push({
      id: 'intervenants',
      label: t('workspace.tabs.intervenants'),
      icon: '👥',
      count: intervenants.value.length
    })
  }
  
  // Tasks tab - only for users with tasks access
  if (canAccessTasks.value) {
    allTabs.push({
      id: 'tasks',
      label: t('workspace.tabs.tasks'),
      icon: '✅',
      count: tasks.value.length
    })
  }
  
  // Overview tab - always available if user has any workspace access (moved to end)
  if (hasWorkspaceAccess.value) {
    allTabs.push({
      id: 'overview',
      label: t('workspace.tabs.overview'),
      icon: '🏠',
      count: undefined
    })
  }
  
  return allTabs
})

// Permission Checks
const hasWorkspaceAccess = computed(() => {
  return hasAnyPermissionForProject([
    PermissionType.ACCESS_PHASES,
    PermissionType.ACCESS_TASKS,
    PermissionType.ACCESS_INTERVENANTS
  ], props.projectId).value
})

const canAccessPhases = computed(() => {
  return hasPermissionForProject(PermissionType.ACCESS_PHASES, props.projectId).value
})

const canAccessTasks = computed(() => {
  return hasPermissionForProject(PermissionType.ACCESS_TASKS, props.projectId).value
})

const canAccessIntervenants = computed(() => {
  return hasPermissionForProject(PermissionType.ACCESS_INTERVENANTS, props.projectId).value
})

// Computed
const searchAndFilteredPhases = computed(() => {
  let result = phases.value

  // Search filter
  if (searchQuery.value) {
    const query = searchQuery.value.toLowerCase()
    result = result.filter((p: Phase) =>
      p.name?.toLowerCase().includes(query) ||
      p.description?.toLowerCase().includes(query)
    )
  }

  // Status filter
  if (filters.value.status.length > 0) {
    result = result.filter((p: Phase) =>
      filters.value.status.includes(p.status || '')
    )
  }

  // Date range filter
  if (filters.value.dateRange.start) {
    result = result.filter((p: Phase) => {
      const startDate = p.plannedStartDate ? new Date(p.plannedStartDate) : null
      const filterStart = new Date(filters.value.dateRange.start)
      return startDate && startDate >= filterStart
    })
  }
  if (filters.value.dateRange.end) {
    result = result.filter((p: Phase) => {
      const endDate = p.plannedEndDate ? new Date(p.plannedEndDate) : null
      const filterEnd = new Date(filters.value.dateRange.end)
      return endDate && endDate <= filterEnd
    })
  }

  return result
})

// Computed - Total pages for phases
const totalPagesPhases = computed(() => {
  return Math.ceil(searchAndFilteredPhases.value.length / itemsPerPage.value)
})

// Computed - Total items for phases
const totalItemsPhases = computed(() => {
  return searchAndFilteredPhases.value.length
})

// Computed - Apply pagination to phases
const filteredPhases = computed(() => {
  if (activeTab.value !== 'phases') {
    return searchAndFilteredPhases.value // Return all when not on phases tab
  }
  const start = (currentPage.value - 1) * itemsPerPage.value
  const end = start + itemsPerPage.value
  return searchAndFilteredPhases.value.slice(start, end)
})

const filteredIntervenants = computed(() => {
  let result = intervenants.value

  // Search filter
  if (searchQuery.value) {
    const query = searchQuery.value.toLowerCase()
    result = result.filter((i: Intervenant) =>
      i.name?.toLowerCase().includes(query) ||
      i.email?.toLowerCase().includes(query) ||
      i.phone?.toLowerCase().includes(query)
    )
  }

  // Intervenant-specific filter (if set from filters)
  if (filters.value.intervenantId) {
    result = result.filter((i: Intervenant) => i.id === filters.value.intervenantId)
  }

  return result
})

const filteredTasks = computed(() => {
  let result = tasks.value

  // Search filter
  if (searchQuery.value) {
    const query = searchQuery.value.toLowerCase()
    result = result.filter((t: Task) =>
      t.name?.toLowerCase().includes(query) ||
      t.description?.toLowerCase().includes(query) ||
      t.intervenantName?.toLowerCase().includes(query)
    )
  }

  // Status filter
  if (filters.value.status.length > 0) {
    result = result.filter((t: Task) =>
      filters.value.status.includes(t.status || '')
    )
  }

  // Date range filter
  if (filters.value.dateRange.start) {
    result = result.filter((t: Task) => {
      const startDate = t.startDate ? new Date(t.startDate) : null
      const filterStart = new Date(filters.value.dateRange.start)
      return startDate && startDate >= filterStart
    })
  }
  if (filters.value.dateRange.end) {
    result = result.filter((t: Task) => {
      const endDate = t.endDate ? new Date(t.endDate) : null
      const filterEnd = new Date(filters.value.dateRange.end)
      return endDate && endDate <= filterEnd
    })
  }

  // Budget range filter
  if (filters.value.budgetRange.max > 0) {
    result = result.filter((t: Task) => {
      const amount = t.amount || 0
      return amount >= filters.value.budgetRange.min && amount <= filters.value.budgetRange.max
    })
  }

  // Assignment filter
  if (!filters.value.assignment.assigned && !filters.value.assignment.unassigned) {
    // If both are false, show nothing
    return []
  }
  if (!filters.value.assignment.assigned) {
    // Show only unassigned
    result = result.filter((t: Task) => !t.intervenantId && !t.phaseId)
  }
  if (!filters.value.assignment.unassigned) {
    // Show only assigned
    result = result.filter((t: Task) => t.intervenantId || t.phaseId)
  }

  // Phase filter
  if (filters.value.phaseId) {
    result = result.filter((t: Task) => t.phaseId === filters.value.phaseId)
  }

  // Intervenant filter
  if (filters.value.intervenantId) {
    result = result.filter((t: Task) => t.intervenantId === filters.value.intervenantId)
  }

  return result
})

const inProgressCount = computed(() => {
  const phasesInProgress = phases.value.filter((p: Phase) => p.status === 'IN_PROGRESS').length
  const tasksInProgress = tasks.value.filter((t: Task) => t.status === 'IN_PROGRESS').length
  return phasesInProgress + tasksInProgress
})

const activePhases = computed(() =>
  phases.value.filter((p: Phase) => p.status === 'IN_PROGRESS').slice(0, 5)
)

const recentTasks = computed(() =>
  [...tasks.value]
    .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
    .slice(0, 5)
)

const unassignedTasks = computed(() =>
  tasks.value.filter((t: Task) => !t.phaseId)
)

// Summary computed properties
const phasesSummary = computed(() => {
  const active = phases.value.filter((p: Phase) => p.status === 'IN_PROGRESS').length
  const completed = phases.value.filter((p: Phase) => p.status === 'COMPLETED').length
  return `${active} ${t('workspace.stats.active')}, ${completed} ${t('workspace.stats.completed')}`
})

const intervenantsSummary = computed(() => {
  const activeCount = getActiveIntervenantsCount()
  return `${activeCount} ${t('workspace.stats.activeContributors')}`
})

const tasksSummary = computed(() => {
  const inProgress = tasks.value.filter((t: Task) => t.status === 'IN_PROGRESS').length
  return `${inProgress} ${t('workspace.stats.inProgress')}`
})

const budgetPercentage = computed(() => {
  const total = getTotalBudget()
  const consumed = getConsumedBudget()
  return total > 0 ? Math.round((consumed / total) * 100) : 0
})

const budgetSummary = computed(() => {
  const consumed = getFormattedAmount('consumed-budget')
  const total = getFormattedAmount('total-budget')
  return `${consumed} / ${total}`
})

// Overview Dashboard Computed Properties
const overdueTasks = computed(() => {
  const now = new Date()
  return tasks.value.filter((t: Task) => {
    if (!t.endDate) return false
    const endDate = new Date(t.endDate)
    return endDate < now && t.status !== 'COMPLETED' && t.status !== 'CANCELLED'
  })
})

const overduePhases = computed(() => {
  const now = new Date()
  return phases.value.filter((p: Phase) => {
    if (!p.plannedEndDate) return false
    const endDate = new Date(p.plannedEndDate)
    return endDate < now && p.status !== 'COMPLETED' && p.status !== 'CANCELLED'
  })
})

const upcomingDeadlines = computed(() => {
  const now = new Date()
  const sevenDaysFromNow = new Date(now.getTime() + 7 * 24 * 60 * 60 * 1000)
  
  const upcomingTasks = tasks.value
    .filter((t: Task) => {
      if (!t.endDate || t.status === 'COMPLETED' || t.status === 'CANCELLED') return false
      const endDate = new Date(t.endDate)
      return endDate >= now && endDate <= sevenDaysFromNow
    })
    .map((t: Task) => ({
      type: 'task',
      id: t.id,
      name: t.name,
      endDate: t.endDate,
      daysRemaining: Math.ceil((new Date(t.endDate!).getTime() - now.getTime()) / (1000 * 60 * 60 * 24)),
      item: t
    }))
  
  const upcomingPhases = phases.value
    .filter((p: Phase) => {
      if (!p.plannedEndDate || p.status === 'COMPLETED' || p.status === 'CANCELLED') return false
      const endDate = new Date(p.plannedEndDate)
      return endDate >= now && endDate <= sevenDaysFromNow
    })
    .map((p: Phase) => ({
      type: 'phase',
      id: p.id,
      name: p.name,
      endDate: p.plannedEndDate,
      daysRemaining: Math.ceil((new Date(p.plannedEndDate!).getTime() - now.getTime()) / (1000 * 60 * 60 * 24)),
      item: p
    }))
  
  return [...upcomingTasks, ...upcomingPhases]
    .sort((a, b) => a.daysRemaining - b.daysRemaining)
    .slice(0, 5)
})

const overdueItems = computed(() => {
  const now = new Date()
  
  const overdueTaskItems = overdueTasks.value.map((t: Task) => ({
    type: 'task',
    id: t.id,
    name: t.name,
    endDate: t.endDate,
    daysLate: Math.ceil((now.getTime() - new Date(t.endDate!).getTime()) / (1000 * 60 * 60 * 24)),
    item: t
  }))
  
  const overduePhaseItems = overduePhases.value.map((p: Phase) => ({
    type: 'phase',
    id: p.id,
    name: p.name,
    endDate: p.plannedEndDate,
    daysLate: Math.ceil((now.getTime() - new Date(p.plannedEndDate!).getTime()) / (1000 * 60 * 60 * 24)),
    item: p
  }))
  
  return [...overdueTaskItems, ...overduePhaseItems]
    .sort((a, b) => b.daysLate - a.daysLate)
    .slice(0, 5)
})

const tasksByStatus = computed(() => {
  const statuses = {
    COMPLETED: 0,
    IN_PROGRESS: 0,
    PENDING: 0,
    ON_HOLD: 0,
    CANCELLED: 0
  }
  
  tasks.value.forEach((t: Task) => {
    const status = t.status || 'PENDING'
    if (status in statuses) {
      statuses[status as keyof typeof statuses]++
    }
  })
  
  return statuses
})

const topActiveIntervenants = computed(() => {
  const intervenantTaskCount = new Map<number, { intervenant: Intervenant; count: number }>()
  
  tasks.value.forEach((t: Task) => {
    if (t.intervenantId && (t.status === 'IN_PROGRESS' || t.status === 'PENDING')) {
      const existing = intervenantTaskCount.get(t.intervenantId)
      if (existing) {
        existing.count++
      } else {
        const intervenant = intervenants.value.find((i: Intervenant) => i.id === t.intervenantId)
        if (intervenant) {
          intervenantTaskCount.set(t.intervenantId, { intervenant, count: 1 })
        }
      }
    }
  })
  
  return Array.from(intervenantTaskCount.values())
    .sort((a, b) => b.count - a.count)
    .slice(0, 5)
})

const budgetBreakdownByPhase = computed(() => {
  return phases.value.map((p: Phase) => {
    const phaseTasks = tasks.value.filter((t: Task) => t.phaseId === p.id)
    const phaseBudget = phaseTasks.reduce((sum: number, t: Task) => sum + (t.amount || 0), 0)
    const total = getTotalBudget()
    const percentage = total > 0 ? Math.round((phaseBudget / total) * 100) : 0
    
    return {
      phase: p,
      budget: phaseBudget,
      percentage,
      taskCount: phaseTasks.length
    }
  }).filter((item: any) => item.budget > 0)
    .sort((a: any, b: any) => b.budget - a.budget)
})

const hasAlerts = computed(() => {
  return overdueTasks.value.length > 0 || 
         overduePhases.value.length > 0 || 
         unassignedTasks.value.length > 0
})

// Methods
const loadData = async () => {
  loading.value = true
  try {
    // First, check if user has any workspace access
    if (!hasWorkspaceAccess.value) {
      notifyError(t('workspace.errors.noAccess'))
      return
    }

    // First, check if we need to load project data
    // Only fetch project data if not already loaded
    if (!project.value || project.value.id !== props.projectId) {
      project.value = await projectService.getProjectById(props.projectId.toString())
    }
    
    // Now prepare API calls based on project configuration and permissions
    const apiCalls: Promise<any>[] = []
    const apiCallMap: string[] = []
    
    // Only fetch intervenants if user has permission
    if (canAccessIntervenants.value) {
      apiCalls.push(intervenantsService.getIntervenants(props.projectId.toString()))
      apiCallMap.push('intervenants')
    }
    
    // Only fetch tasks if user has permission
    if (canAccessTasks.value) {
      apiCalls.push(projectTasksService.getTasks(props.projectId.toString()))
      apiCallMap.push('tasks')
    }
    
    // Only fetch phases if the project is multi-phase and user has permission
    if (project.value?.multiPhase && canAccessPhases.value) {
      apiCalls.push(projectPhasesService.getPhases(props.projectId.toString()))
      apiCallMap.push('phases')
    }
    
    // Skip budget report for clients in FULL_MANAGEMENT projects
    if (apiCalls.length > 0 && !hideBudgetFromClient.value) {
      apiCalls.push(reportService.getBudgetConsumptionReport(props.projectId.toString()))
      apiCallMap.push('budget')
    }
    
    // Execute API calls in parallel
    const results = await Promise.all(apiCalls)
    
    // Assign results based on what was fetched
    for (let i = 0; i < results.length; i++) {
      const dataType = apiCallMap[i]
      switch (dataType) {
        case 'intervenants':
          intervenants.value = results[i] || []
          break
        case 'tasks':
          tasks.value = results[i] || []
          break
        case 'phases':
          phases.value = results[i] || []
          break
        case 'budget':
          budgetReport.value = results[i] || null
          break
      }
    }
    
    // Clear data for which user doesn't have permissions
    if (!canAccessIntervenants.value) {
      intervenants.value = []
    }
    if (!canAccessTasks.value) {
      tasks.value = []
    }
    if (!canAccessPhases.value) {
      phases.value = []
    }
    
    // Initialize the default tab based on project type and permissions
    initializeDefaultTab()
    
    // Format all amounts after loading data
    await formatAllAmounts()
  } catch (error) {
    notifyError(t('workspace.errors.loadFailed'))
  } finally {
    loading.value = false
  }
}

// Format all amounts for phases, tasks, and budget summary
const formatAllAmounts = async () => {
  try {
    // Format task amounts
    for (const task of tasks.value) {
      if (task.id && task.amount !== undefined) {
        const key = `task-${task.id}`
        await formatCurrency(task.amount, key)
      }
    }
    
    // Format phase budgets
    for (const phase of phases.value) {
      if (phase.id) {
        const phaseBudget = getPhaseBudget(phase.id)
        const key = `phase-${phase.id}`
        await formatCurrency(phaseBudget, key)
      }
    }
    
    // Format budget summary
    const totalBudget = getTotalBudget()
    const consumedBudget = getConsumedBudget()
    await formatCurrency(totalBudget, 'total-budget')
    await formatCurrency(consumedBudget, 'consumed-budget')
  } catch (error) {
    console.warn('Error formatting amounts:', error)
  }
}

const switchTab = (tabId: string) => {
  activeTab.value = tabId
  currentPage.value = 1 // Reset to page 1 when switching tabs
  clearSelection()
}

// Pagination methods
const goToPage = (page: number) => {
  if (page >= 1 && page <= totalPagesPhases.value) {
    currentPage.value = page
  }
}

const nextPage = () => {
  if (currentPage.value < totalPagesPhases.value) {
    currentPage.value++
  }
}

const previousPage = () => {
  if (currentPage.value > 1) {
    currentPage.value--
  }
}

const changeItemsPerPage = (value: number) => {
  itemsPerPage.value = value
  currentPage.value = 1 // Reset to first page when changing items per page
}

// Helper to determine which page numbers to show (with ellipsis logic)
const shouldShowPage = (page: number) => {
  if (totalPagesPhases.value <= 7) {
    return true // Show all pages if 7 or fewer
  }
  
  // Always show first page, last page, current page, and adjacent pages
  if (page === 1 || page === totalPagesPhases.value) {
    return true
  }
  
  if (Math.abs(page - currentPage.value) <= 1) {
    return true
  }
  
  return false
}

// Filter Management
const toggleStatusFilter = (status: string) => {
  const index = filters.value.status.indexOf(status)
  if (index > -1) {
    filters.value.status.splice(index, 1)
  } else {
    filters.value.status.push(status)
  }
  currentPage.value = 1 // Reset to page 1 when filter changes
}

const clearFilters = () => {
  filters.value = {
    status: [],
    dateRange: {
      start: '',
      end: ''
    },
    budgetRange: {
      min: 0,
      max: 0
    },
    assignment: {
      assigned: true,
      unassigned: true
    },
    phaseId: null,
    intervenantId: null
  }
  currentPage.value = 1 // Reset to page 1 when clearing filters
}

const hasActiveFilters = computed(() => {
  return filters.value.status.length > 0 ||
    filters.value.dateRange.start !== '' ||
    filters.value.dateRange.end !== '' ||
    filters.value.budgetRange.max > 0 ||
    (!filters.value.assignment.assigned || !filters.value.assignment.unassigned) ||
    filters.value.phaseId !== null ||
    filters.value.intervenantId !== null
})

const activeFilterCount = computed(() => {
  let count = 0
  if (filters.value.status.length > 0) count++
  if (filters.value.dateRange.start || filters.value.dateRange.end) count++
  if (filters.value.budgetRange.max > 0) count++
  if (!filters.value.assignment.assigned || !filters.value.assignment.unassigned) count++
  if (filters.value.phaseId) count++
  if (filters.value.intervenantId) count++
  return count
})

const selectPhase = (phase: any) => {
  selectedPhase.value = phase
  selectedIntervenant.value = null
  selectedTask.value = null
}

const selectIntervenant = (intervenant: any) => {
  selectedIntervenant.value = intervenant
  selectedPhase.value = null
  selectedTask.value = null
}

const selectTask = (task: any) => {
  selectedTask.value = task
  selectedPhase.value = null
  selectedIntervenant.value = null
}

const clearSelection = () => {
  selectedPhase.value = null
  selectedIntervenant.value = null
  selectedTask.value = null
}

// Phase Actions
const editPhase = (phase: any) => {
  if (!hasPermissionForProject(PermissionType.UPDATE_PHASE, props.projectId).value) {
    notifyError(t('workspace.errors.noPermission'))
    return
  }
  editingPhase.value = phase
  showPhaseModal.value = true
}

const configurePhase = (phase: any) => {
  if (!hasPermissionForProject(PermissionType.UPDATE_PHASE, props.projectId).value) {
    notifyError(t('workspace.errors.noPermission'))
    return
  }
  router.push({
    name: 'PhaseConfigurer',
    params: {
      projectId: props.projectId.toString(),
      phaseId: phase.id.toString()
    }
  })
}

const openPhaseWorkspace = (phase: any) => {
  if (!hasPermissionForProject(PermissionType.ACCESS_PHASES, props.projectId).value) {
    notifyError(t('workspace.errors.noPermission'))
    return
  }
  router.push({
    name: 'PhaseWorkspace',
    params: {
      projectId: props.projectId.toString(),
      phaseId: phase.id.toString()
    }
  })
}

const deletePhase = (id: number) => {
  if (!hasPermissionForProject(PermissionType.DELETE_PHASE, props.projectId).value) {
    notifyError(t('workspace.errors.noPermission'))
    return
  }
  const phase = phases.value.find((p: Phase) => p.id === id)
  deletePhaseId.value = id
  deletePhaseMessage.value = phase?.name || ''
  showDeletePhaseConfirm.value = true
}

const confirmDeletePhase = async () => {
  if (deletePhaseId.value === null) return
  
  if (!hasPermissionForProject(PermissionType.DELETE_PHASE, props.projectId).value) {
    notifyError(t('workspace.errors.noPermission'))
    return
  }
  
  try {
    await projectPhasesService.deletePhase(
      props.projectId.toString(), 
      deletePhaseId.value.toString()
    )
    notifySuccess(t('workspace.success.phaseDeleted'))
    await loadData()
  } catch (error) {
    notifyError(t('workspace.errors.phaseDeleteFailed'))
  } finally {
    cancelDeletePhase()
  }
}

const cancelDeletePhase = () => {
  showDeletePhaseConfirm.value = false
  deletePhaseId.value = null
  deletePhaseMessage.value = ''
}

const closePhaseModal = () => {
  showPhaseModal.value = false
  editingPhase.value = null
}

const handlePhaseSaved = () => {
  closePhaseModal()
  loadData()
  // Use generic success message since this handles both create and update
  notifySuccess(editingPhase.value?.id ? t('workspace.success.phaseUpdated') : t('workspace.success.phaseCreated'))
}

const handlePhaseCreated = () => {
  loadData()
  notifySuccess(t('workspace.success.phaseCreated'))
}

const handlePhaseUpdated = () => {
  loadData()
  notifySuccess(t('workspace.success.phaseUpdated'))
}

const handlePhaseDeleted = () => {
  loadData()
  notifySuccess(t('workspace.success.phaseDeleted'))
}

const closeIntervenantModal = () => {
  showIntervenantModal.value = false
}

const handleIntervenantSaved = () => {
  closeIntervenantModal()
  loadData()
}

// Task actions are now handled by WorkspaceTasksTab component
const closeTaskModal = () => {
  showTaskModal.value = false
}

const handleTaskSaved = () => {
  closeTaskModal()
  loadData()
}
const handleTaskCreated = () => {
  loadData()
  notifySuccess(t('workspace.success.taskCreated'))
}

const handleTaskUpdated = () => {
  loadData()
  notifySuccess(t('workspace.success.taskUpdated'))
}

const handleTaskDeleted = () => {
  loadData()
  notifySuccess(t('workspace.success.taskDeleted'))
}

// Helper Methods
const getPhaseTaskCount = (phaseId: number) => {
  return tasks.value.filter((t: Task) => t.phaseId === phaseId).length
}

const getIntervenantTaskCount = (intervenantId: number) => {
  return tasks.value.filter((t: Task) => t.intervenantId === intervenantId).length
}

const getTasksForPhase = (phaseId: number) => {
  return tasks.value.filter((t: Task) => t.phaseId === phaseId)
}

// getTasksForIntervenant is now provided by useProjectPhases composable

// Reactive formatted amounts
const formattedAmounts = ref<Record<string, string>>({})

const formatCurrency = async (amount: number, key?: string) => {
  if (amount === null || amount === undefined) return '-'
  try {
    const formatted = await formatCurrencyWithUserPreference(amount)
    if (key) {
      formattedAmounts.value[key] = formatted
    }
    return formatted
  } catch (err) {
    console.warn('Error formatting currency:', err)
    return amount.toString()
  }
}

const getFormattedAmount = (key: string) => {
  return formattedAmounts.value[key] || '...'
}

// Quick Add Dropdown
const toggleQuickAdd = () => {
  showQuickAdd.value = !showQuickAdd.value
}

const openPhaseModal = () => {
  if (!hasPermissionForProject(PermissionType.CREATE_PHASE, props.projectId).value) {
    notifyError(t('workspace.errors.noPermission'))
    return
  }
  showQuickAdd.value = false
  editingPhase.value = null
  showPhaseModal.value = true
}

const openIntervenantModal = () => {
  if (!hasPermissionForProject(PermissionType.CREATE_INTERVENANT, props.projectId).value) {
    notifyError(t('workspace.errors.noPermission'))
    return
  }
  showQuickAdd.value = false
  showIntervenantModal.value = true
}

const openTaskModal = () => {
  if (!hasPermissionForProject(PermissionType.CREATE_TASK, props.projectId).value) {
    notifyError(t('workspace.errors.noPermission'))
    return
  }
  showQuickAdd.value = false
  showTaskModal.value = true
}

// Progress Calculations - Now handled by useProjectPhases composable
// getPhaseProgress, getPhaseBudget, getPhaseIntervenants, getActiveIntervenantsCount, getTotalBudget
// are now destructured from useProjectPhases

const getConsumedBudget = () => {
  // Use backend calculation if available (based on actual expense transactions)
  if (budgetReport.value && budgetReport.value.totalConsumed !== undefined) {
    return budgetReport.value.totalConsumed
  }
  
  // Fallback to frontend calculation (based on task status)
  return tasks.value
    .filter((t: Task) => t.status === 'COMPLETED' || t.status === 'IN_PROGRESS')
    .reduce((sum: number, task: Task) => sum + (task.amount || 0), 0)
}

// Close dropdown when clicking outside
const handleClickOutside = (event: MouseEvent) => {
  if (quickAddDropdown.value && !quickAddDropdown.value.contains(event.target as Node)) {
    showQuickAdd.value = false
  }
}

// Close panel when pressing Escape key
const handleEscapeKey = (event: KeyboardEvent) => {
  if (event.key === 'Escape') {
    if (selectedPhase.value || selectedIntervenant.value || selectedTask.value) {
      clearSelection()
    } else if (showQuickAdd.value) {
      showQuickAdd.value = false
    }
  }
}

// Lifecycle
onMounted(() => {
  loadData()
  document.addEventListener('click', handleClickOutside)
  document.addEventListener('keydown', handleEscapeKey)
})

watch(() => props.projectId, () => {
  loadData()
})

watch(searchQuery, () => {
  currentPage.value = 1
})

// Cleanup
onBeforeUnmount(() => {
  document.removeEventListener('click', handleClickOutside)
  document.removeEventListener('keydown', handleEscapeKey)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PermissionGuard, {
    "any-permissions": ['ACCESS_PHASES', 'ACCESS_TASKS', 'ACCESS_INTERVENANTS'],
    "project-id": _ctx.projectId
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('workspace.subtitle')), 1)
            ]),
            _createElementVNode("div", {
              class: "quick-add-dropdown",
              ref_key: "quickAddDropdown",
              ref: quickAddDropdown
            }, [
              _createVNode(PermissionGuard, {
                "any-permissions": ['CREATE_PHASE', 'CREATE_INTERVENANT', 'CREATE_TASK'],
                "project-id": _ctx.projectId
              }, {
                default: _withCtx(() => [
                  _createElementVNode("button", {
                    class: "btn btn-primary",
                    onClick: toggleQuickAdd
                  }, [
                    _cache[22] || (_cache[22] = _createElementVNode("span", { class: "btn-icon" }, "➕", -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('workspace.actions.quickAdd')) + " ", 1),
                    _cache[23] || (_cache[23] = _createElementVNode("span", { class: "dropdown-arrow" }, "▼", -1))
                  ])
                ]),
                _: 1
              }, 8, ["project-id"]),
              (showQuickAdd.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    (project.value?.multiPhase)
                      ? (_openBlock(), _createBlock(PermissionGuard, {
                          key: 0,
                          permission: "CREATE_PHASE",
                          "project-id": _ctx.projectId
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", {
                              class: "dropdown-item",
                              onClick: openPhaseModal
                            }, [
                              _cache[24] || (_cache[24] = _createElementVNode("span", { class: "item-icon" }, "📊", -1)),
                              _createElementVNode("span", null, _toDisplayString(_ctx.$t('workspace.actions.newPhase')), 1)
                            ])
                          ]),
                          _: 1
                        }, 8, ["project-id"]))
                      : _createCommentVNode("", true),
                    _createVNode(PermissionGuard, {
                      permission: "CREATE_INTERVENANT",
                      "project-id": _ctx.projectId
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: "dropdown-item",
                          onClick: openIntervenantModal
                        }, [
                          _cache[25] || (_cache[25] = _createElementVNode("span", { class: "item-icon" }, "👤", -1)),
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t('workspace.actions.newIntervenant')), 1)
                        ])
                      ]),
                      _: 1
                    }, 8, ["project-id"]),
                    _createVNode(PermissionGuard, {
                      permission: "CREATE_TASK",
                      "project-id": _ctx.projectId
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: "dropdown-item",
                          onClick: openTaskModal
                        }, [
                          _cache[26] || (_cache[26] = _createElementVNode("span", { class: "item-icon" }, "✅", -1)),
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t('workspace.actions.newTask')), 1)
                        ])
                      ]),
                      _: 1
                    }, 8, ["project-id"])
                  ]))
                : _createCommentVNode("", true)
            ], 512)
          ]),
          _createElementVNode("div", _hoisted_7, [
            (project.value?.multiPhase)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "stat-card",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (switchTab('phases')))
                }, [
                  _cache[27] || (_cache[27] = _createElementVNode("div", { class: "stat-icon" }, "📊", -1)),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, _toDisplayString(phases.value.length), 1),
                    _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('workspace.stats.phases')), 1),
                    _createElementVNode("div", _hoisted_11, _toDisplayString(phasesSummary.value), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: "stat-card",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (switchTab('intervenants')))
            }, [
              _cache[28] || (_cache[28] = _createElementVNode("div", { class: "stat-icon" }, "👥", -1)),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, _toDisplayString(intervenants.value.length), 1),
                _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('workspace.stats.intervenants')), 1),
                _createElementVNode("div", _hoisted_15, _toDisplayString(intervenantsSummary.value), 1)
              ])
            ]),
            _createElementVNode("div", {
              class: "stat-card",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (switchTab('tasks')))
            }, [
              _cache[29] || (_cache[29] = _createElementVNode("div", { class: "stat-icon" }, "✅", -1)),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, _toDisplayString(tasks.value.length), 1),
                _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t('workspace.stats.tasks')), 1),
                _createElementVNode("div", _hoisted_19, _toDisplayString(tasksSummary.value), 1)
              ])
            ]),
            (!hideBudgetFromClient.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _cache[30] || (_cache[30] = _createElementVNode("div", { class: "stat-icon" }, "💰", -1)),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, _toDisplayString(budgetPercentage.value) + "%", 1),
                    _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$t('workspace.stats.budgetUsed')), 1),
                    _createElementVNode("div", _hoisted_24, _toDisplayString(budgetSummary.value), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, (tab) => {
              return (_openBlock(), _createElementBlock("button", {
                key: tab.id,
                class: _normalizeClass(['tab-button', { active: activeTab.value === tab.id }]),
                onClick: ($event: any) => (switchTab(tab.id))
              }, [
                _createElementVNode("span", {
                  class: "tab-icon",
                  innerHTML: tab.icon
                }, null, 8, _hoisted_28),
                _createElementVNode("span", _hoisted_29, _toDisplayString(tab.label), 1),
                (tab.count !== undefined)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(tab.count), 1))
                  : _createCommentVNode("", true)
              ], 10, _hoisted_27))
            }), 128))
          ]),
          _createVNode(_Transition, { name: "slide-down" }, {
            default: _withCtx(() => [
              (showFilters.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("h3", null, _toDisplayString(_ctx.$t('workspace.filters.title')), 1),
                      (hasActiveFilters.value)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "btn-text",
                            onClick: clearFilters
                          }, _toDisplayString(_ctx.$t('workspace.filters.clearAll')), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("label", _hoisted_35, _toDisplayString(_ctx.$t('workspace.filters.status')), 1),
                        _createElementVNode("div", _hoisted_36, [
                          _createElementVNode("label", _hoisted_37, [
                            _createElementVNode("input", {
                              type: "checkbox",
                              checked: filters.value.status.includes('NOT_STARTED'),
                              onChange: _cache[3] || (_cache[3] = ($event: any) => (toggleStatusFilter('NOT_STARTED')))
                            }, null, 40, _hoisted_38),
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t('workspace.filters.statuses.notStarted')), 1)
                          ]),
                          _createElementVNode("label", _hoisted_39, [
                            _createElementVNode("input", {
                              type: "checkbox",
                              checked: filters.value.status.includes('IN_PROGRESS'),
                              onChange: _cache[4] || (_cache[4] = ($event: any) => (toggleStatusFilter('IN_PROGRESS')))
                            }, null, 40, _hoisted_40),
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t('workspace.filters.statuses.inProgress')), 1)
                          ]),
                          _createElementVNode("label", _hoisted_41, [
                            _createElementVNode("input", {
                              type: "checkbox",
                              checked: filters.value.status.includes('COMPLETED'),
                              onChange: _cache[5] || (_cache[5] = ($event: any) => (toggleStatusFilter('COMPLETED')))
                            }, null, 40, _hoisted_42),
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t('workspace.filters.statuses.completed')), 1)
                          ]),
                          _createElementVNode("label", _hoisted_43, [
                            _createElementVNode("input", {
                              type: "checkbox",
                              checked: filters.value.status.includes('ON_HOLD'),
                              onChange: _cache[6] || (_cache[6] = ($event: any) => (toggleStatusFilter('ON_HOLD')))
                            }, null, 40, _hoisted_44),
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t('workspace.filters.statuses.onHold')), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_45, [
                        _createElementVNode("label", _hoisted_46, _toDisplayString(_ctx.$t('workspace.filters.dateRange')), 1),
                        _createElementVNode("div", _hoisted_47, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((filters.value.dateRange.start) = $event)),
                            type: "date",
                            placeholder: _ctx.$t('workspace.filters.startDate'),
                            class: "filter-input"
                          }, null, 8, _hoisted_48), [
                            [_vModelText, filters.value.dateRange.start]
                          ]),
                          _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.$t('workspace.filters.to')), 1),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((filters.value.dateRange.end) = $event)),
                            type: "date",
                            placeholder: _ctx.$t('workspace.filters.endDate'),
                            class: "filter-input"
                          }, null, 8, _hoisted_50), [
                            [_vModelText, filters.value.dateRange.end]
                          ])
                        ])
                      ]),
                      (activeTab.value === 'tasks')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                            _createElementVNode("label", _hoisted_52, _toDisplayString(_ctx.$t('workspace.filters.budgetRange')), 1),
                            _createElementVNode("div", _hoisted_53, [
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((filters.value.budgetRange.min) = $event)),
                                type: "number",
                                placeholder: _ctx.$t('workspace.filters.minAmount'),
                                class: "filter-input",
                                min: "0"
                              }, null, 8, _hoisted_54), [
                                [
                                  _vModelText,
                                  filters.value.budgetRange.min,
                                  void 0,
                                  { number: true }
                                ]
                              ]),
                              _createElementVNode("span", _hoisted_55, _toDisplayString(_ctx.$t('workspace.filters.to')), 1),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((filters.value.budgetRange.max) = $event)),
                                type: "number",
                                placeholder: _ctx.$t('workspace.filters.maxAmount'),
                                class: "filter-input",
                                min: "0"
                              }, null, 8, _hoisted_56), [
                                [
                                  _vModelText,
                                  filters.value.budgetRange.max,
                                  void 0,
                                  { number: true }
                                ]
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (activeTab.value === 'tasks')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                            _createElementVNode("label", _hoisted_58, _toDisplayString(_ctx.$t('workspace.filters.assignment')), 1),
                            _createElementVNode("div", _hoisted_59, [
                              _createElementVNode("label", _hoisted_60, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "checkbox",
                                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((filters.value.assignment.assigned) = $event))
                                }, null, 512), [
                                  [_vModelCheckbox, filters.value.assignment.assigned]
                                ]),
                                _createElementVNode("span", null, _toDisplayString(_ctx.$t('workspace.filters.assigned')), 1)
                              ]),
                              _createElementVNode("label", _hoisted_61, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "checkbox",
                                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((filters.value.assignment.unassigned) = $event))
                                }, null, 512), [
                                  [_vModelCheckbox, filters.value.assignment.unassigned]
                                ]),
                                _createElementVNode("span", null, _toDisplayString(_ctx.$t('workspace.filters.unassigned')), 1)
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (activeTab.value === 'tasks')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                            _createElementVNode("label", _hoisted_63, _toDisplayString(_ctx.$t('workspace.filters.phase')), 1),
                            _withDirectives(_createElementVNode("select", {
                              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((filters.value.phaseId) = $event)),
                              class: "filter-select"
                            }, [
                              _createElementVNode("option", _hoisted_64, _toDisplayString(_ctx.$t('workspace.filters.allPhases')), 1),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(phases.value, (phase) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: phase.id,
                                  value: phase.id
                                }, _toDisplayString(phase.name), 9, _hoisted_65))
                              }), 128))
                            ], 512), [
                              [_vModelSelect, filters.value.phaseId]
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (activeTab.value === 'tasks')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                            _createElementVNode("label", _hoisted_67, _toDisplayString(_ctx.$t('workspace.filters.intervenant')), 1),
                            _withDirectives(_createElementVNode("select", {
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((filters.value.intervenantId) = $event)),
                              class: "filter-select"
                            }, [
                              _createElementVNode("option", _hoisted_68, _toDisplayString(_ctx.$t('workspace.filters.allIntervenants')), 1),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(intervenants.value, (intervenant) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: intervenant.id,
                                  value: intervenant.id
                                }, _toDisplayString(intervenant.name), 9, _hoisted_69))
                              }), 128))
                            ], 512), [
                              [_vModelSelect, filters.value.intervenantId]
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_70, [
            (loading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                  _cache[31] || (_cache[31] = _createElementVNode("div", { class: "loading-spinner" }, null, -1)),
                  _createElementVNode("p", null, _toDisplayString(_ctx.$t('common.loading')), 1)
                ]))
              : (activeTab.value === 'phases' && project.value?.multiPhase)
                ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                    _createVNode(WorkspacePhasesTab, {
                      "project-id": _ctx.projectId,
                      phases: phases.value,
                      tasks: tasks.value,
                      "all-intervenants": intervenants.value,
                      "get-phase-progress": _unref(getPhaseProgress),
                      "get-phase-budget": _unref(getPhaseBudget),
                      "get-phase-intervenants": _unref(getPhaseIntervenants),
                      "show-search": true,
                      onPhaseSelected: selectPhase,
                      onPhaseCreated: handlePhaseCreated,
                      onPhaseUpdated: handlePhaseUpdated,
                      onPhaseDeleted: handlePhaseDeleted
                    }, null, 8, ["project-id", "phases", "tasks", "all-intervenants", "get-phase-progress", "get-phase-budget", "get-phase-intervenants"])
                  ]))
                : (activeTab.value === 'intervenants')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                      _createVNode(WorkspaceIntervenantsTab, {
                        "project-id": _ctx.projectId,
                        intervenants: intervenants.value,
                        tasks: tasks.value,
                        "filtered-intervenants": filteredIntervenants.value,
                        "show-search": true,
                        "show-filters": true,
                        onIntervenantSelected: selectIntervenant,
                        onIntervenantAssigned: _ctx.loadWorkspaceData,
                        onIntervenantUnassigned: _ctx.loadWorkspaceData
                      }, null, 8, ["project-id", "intervenants", "tasks", "filtered-intervenants", "onIntervenantAssigned", "onIntervenantUnassigned"])
                    ]))
                  : (activeTab.value === 'tasks')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                        _createVNode(WorkspaceTasksTab, {
                          "project-id": _ctx.projectId,
                          tasks: tasks.value,
                          "all-intervenants": intervenants.value,
                          phases: phases.value,
                          project: project.value,
                          "filtered-tasks": filteredTasks.value,
                          "show-search": true,
                          "show-filters": true,
                          "show-phase-column": project.value?.multiPhase,
                          onTaskSelected: selectTask,
                          onTaskCreated: handleTaskCreated,
                          onTaskUpdated: handleTaskUpdated,
                          onTaskDeleted: handleTaskDeleted
                        }, null, 8, ["project-id", "tasks", "all-intervenants", "phases", "project", "filtered-tasks", "show-phase-column"])
                      ]))
                    : (activeTab.value === 'overview')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                          _createElementVNode("div", _hoisted_76, [
                            _createElementVNode("h3", _hoisted_77, [
                              _cache[32] || (_cache[32] = _createElementVNode("span", { class: "title-icon" }, "⚠️", -1)),
                              _createTextVNode(" " + _toDisplayString(_ctx.$t('workspace.overview.alertsIssues')), 1)
                            ]),
                            (hasAlerts.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                                  (overdueTasks.value.length > 0)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: "alert-item alert-danger",
                                        onClick: _cache[15] || (_cache[15] = ($event: any) => (switchTab('tasks')))
                                      }, [
                                        _cache[33] || (_cache[33] = _createElementVNode("span", { class: "alert-icon" }, "🔴", -1)),
                                        _createElementVNode("span", _hoisted_79, _toDisplayString(_ctx.$t('workspace.overview.overdueTasksCount', { count: overdueTasks.value.length })), 1),
                                        _cache[34] || (_cache[34] = _createElementVNode("span", { class: "alert-action" }, "→", -1))
                                      ]))
                                    : _createCommentVNode("", true),
                                  (overduePhases.value.length > 0)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 1,
                                        class: "alert-item alert-warning",
                                        onClick: _cache[16] || (_cache[16] = ($event: any) => (switchTab('phases')))
                                      }, [
                                        _cache[35] || (_cache[35] = _createElementVNode("span", { class: "alert-icon" }, "🟡", -1)),
                                        _createElementVNode("span", _hoisted_80, _toDisplayString(_ctx.$t('workspace.overview.phasesBehindSchedule', { count: overduePhases.value.length })), 1),
                                        _cache[36] || (_cache[36] = _createElementVNode("span", { class: "alert-action" }, "→", -1))
                                      ]))
                                    : _createCommentVNode("", true),
                                  (unassignedTasks.value.length > 0)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 2,
                                        class: "alert-item alert-info",
                                        onClick: _cache[17] || (_cache[17] = ($event: any) => (switchTab('tasks')))
                                      }, [
                                        _cache[37] || (_cache[37] = _createElementVNode("span", { class: "alert-icon" }, "ℹ️", -1)),
                                        _createElementVNode("span", _hoisted_81, _toDisplayString(_ctx.$t('workspace.overview.unassignedTasksCount', { count: unassignedTasks.value.length })), 1),
                                        _cache[38] || (_cache[38] = _createElementVNode("span", { class: "alert-action" }, "→", -1))
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_82, [
                                  _cache[39] || (_cache[39] = _createElementVNode("span", { class: "success-icon" }, "✅", -1)),
                                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('workspace.overview.noAlerts')), 1)
                                ]))
                          ]),
                          _createElementVNode("div", _hoisted_83, [
                            _createElementVNode("div", _hoisted_84, [
                              _createElementVNode("h3", _hoisted_85, [
                                _cache[40] || (_cache[40] = _createElementVNode("span", { class: "title-icon" }, "📅", -1)),
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('workspace.overview.upcomingDays')), 1)
                              ]),
                              (upcomingDeadlines.value.length)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(upcomingDeadlines.value, (item) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: `${item.type}-${item.id}`,
                                        class: "deadline-item",
                                        onClick: ($event: any) => (item.type === 'task' ? (switchTab('tasks'), selectTask(item.item)) : (switchTab('phases'), selectPhase(item.item)))
                                      }, [
                                        _createElementVNode("div", {
                                          class: _normalizeClass(["deadline-icon", `icon-${item.type}`])
                                        }, _toDisplayString(item.type === 'task' ? '✅' : '📊'), 3),
                                        _createElementVNode("div", _hoisted_88, [
                                          _createElementVNode("div", _hoisted_89, _toDisplayString(item.name), 1),
                                          _createElementVNode("div", _hoisted_90, [
                                            _createElementVNode("span", _hoisted_91, _toDisplayString(_ctx.$t('workspace.overview.daysRemaining', { count: item.daysRemaining })), 1)
                                          ])
                                        ])
                                      ], 8, _hoisted_87))
                                    }), 128))
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_92, [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('workspace.overview.noUpcoming')), 1)
                                  ]))
                            ]),
                            _createElementVNode("div", _hoisted_93, [
                              _createElementVNode("h3", _hoisted_94, [
                                _cache[41] || (_cache[41] = _createElementVNode("span", { class: "title-icon" }, "⏰", -1)),
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('workspace.overview.overdueItems')), 1)
                              ]),
                              (overdueItems.value.length)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(overdueItems.value, (item) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: `${item.type}-${item.id}`,
                                        class: "deadline-item deadline-overdue",
                                        onClick: ($event: any) => (item.type === 'task' ? (switchTab('tasks'), selectTask(item.item)) : (switchTab('phases'), selectPhase(item.item)))
                                      }, [
                                        _createElementVNode("div", {
                                          class: _normalizeClass(["deadline-icon", `icon-${item.type}`])
                                        }, _toDisplayString(item.type === 'task' ? '✅' : '📊'), 3),
                                        _createElementVNode("div", _hoisted_97, [
                                          _createElementVNode("div", _hoisted_98, _toDisplayString(item.name), 1),
                                          _createElementVNode("div", _hoisted_99, [
                                            _createElementVNode("span", _hoisted_100, _toDisplayString(_ctx.$t('workspace.overview.daysLate', { count: item.daysLate })), 1)
                                          ])
                                        ])
                                      ], 8, _hoisted_96))
                                    }), 128))
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_101, [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('workspace.overview.noOverdue')), 1)
                                  ]))
                            ])
                          ]),
                          (!hideBudgetFromClient.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
                                _createElementVNode("h3", _hoisted_103, [
                                  _cache[42] || (_cache[42] = _createElementVNode("span", { class: "title-icon" }, "💰", -1)),
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t('workspace.overview.budgetOverview')), 1)
                                ]),
                                _createElementVNode("div", _hoisted_104, [
                                  _createElementVNode("div", _hoisted_105, [
                                    _createElementVNode("div", _hoisted_106, [
                                      _createElementVNode("div", {
                                        class: _normalizeClass(["budget-fill", { 
                      'budget-normal': budgetPercentage.value <= 75,
                      'budget-warning': budgetPercentage.value > 75 && budgetPercentage.value <= 90,
                      'budget-danger': budgetPercentage.value > 90
                    }]),
                                        style: _normalizeStyle({ width: Math.min(budgetPercentage.value, 100) + '%' })
                                      }, null, 6)
                                    ]),
                                    _createElementVNode("div", _hoisted_107, [
                                      _createElementVNode("span", _hoisted_108, _toDisplayString(_ctx.$t('workspace.overview.budgetUsed', { percentage: budgetPercentage.value })), 1),
                                      _createElementVNode("span", _hoisted_109, _toDisplayString(budgetSummary.value), 1)
                                    ])
                                  ])
                                ]),
                                (project.value?.multiPhase && budgetBreakdownByPhase.value.length)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_110, [
                                      _createElementVNode("h4", _hoisted_111, _toDisplayString(_ctx.$t('workspace.overview.budgetByPhase')), 1),
                                      _createElementVNode("div", _hoisted_112, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(budgetBreakdownByPhase.value.slice(0, 3), (item) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            key: item.phase.id,
                                            class: "breakdown-item",
                                            onClick: ($event: any) => {switchTab('phases'); selectPhase(item.phase)}
                                          }, [
                                            _createElementVNode("span", _hoisted_114, _toDisplayString(item.phase.name), 1),
                                            _createElementVNode("span", _hoisted_115, _toDisplayString(item.percentage) + "%", 1)
                                          ], 8, _hoisted_113))
                                        }), 128))
                                      ])
                                    ]))
                                  : (project.value?.multiPhase)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_116, [
                                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('workspace.overview.noBudgetData')), 1)
                                      ]))
                                    : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_117, [
                            _createElementVNode("div", _hoisted_118, [
                              _createElementVNode("h3", _hoisted_119, [
                                _cache[43] || (_cache[43] = _createElementVNode("span", { class: "title-icon" }, "👥", -1)),
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('workspace.overview.topActiveIntervenants')), 1)
                              ]),
                              (topActiveIntervenants.value.length)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_120, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(topActiveIntervenants.value, (item) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: item.intervenant.id,
                                        class: "intervenant-item",
                                        onClick: ($event: any) => {switchTab('intervenants'); selectIntervenant(item.intervenant)}
                                      }, [
                                        _createElementVNode("div", {
                                          class: "intervenant-avatar",
                                          style: _normalizeStyle({ backgroundColor: _unref(getAvatarColor)(item.intervenant.name!) })
                                        }, _toDisplayString(_unref(getInitials)(item.intervenant.name!)), 5),
                                        _createElementVNode("div", _hoisted_122, [
                                          _createElementVNode("div", _hoisted_123, _toDisplayString(item.intervenant.name), 1),
                                          _createElementVNode("div", _hoisted_124, _toDisplayString(_ctx.$t('workspace.overview.tasksCount', { count: item.count })), 1)
                                        ])
                                      ], 8, _hoisted_121))
                                    }), 128))
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_125, [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('workspace.overview.noIntervenants')), 1)
                                  ]))
                            ]),
                            _createElementVNode("div", _hoisted_126, [
                              _createElementVNode("h3", _hoisted_127, [
                                _cache[44] || (_cache[44] = _createElementVNode("span", { class: "title-icon" }, "📊", -1)),
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('workspace.overview.tasksByStatus')), 1)
                              ]),
                              _createElementVNode("div", _hoisted_128, [
                                _createElementVNode("div", {
                                  class: "status-item",
                                  onClick: _cache[18] || (_cache[18] = ($event: any) => (switchTab('tasks')))
                                }, [
                                  _cache[45] || (_cache[45] = _createElementVNode("div", { class: "status-indicator status-completed" }, null, -1)),
                                  _createElementVNode("span", _hoisted_129, _toDisplayString(_ctx.$t('tasks.status.COMPLETED')), 1),
                                  _createElementVNode("span", _hoisted_130, _toDisplayString(tasksByStatus.value.COMPLETED), 1)
                                ]),
                                _createElementVNode("div", {
                                  class: "status-item",
                                  onClick: _cache[19] || (_cache[19] = ($event: any) => (switchTab('tasks')))
                                }, [
                                  _cache[46] || (_cache[46] = _createElementVNode("div", { class: "status-indicator status-in-progress" }, null, -1)),
                                  _createElementVNode("span", _hoisted_131, _toDisplayString(_ctx.$t('tasks.status.IN_PROGRESS')), 1),
                                  _createElementVNode("span", _hoisted_132, _toDisplayString(tasksByStatus.value.IN_PROGRESS), 1)
                                ]),
                                _createElementVNode("div", {
                                  class: "status-item",
                                  onClick: _cache[20] || (_cache[20] = ($event: any) => (switchTab('tasks')))
                                }, [
                                  _cache[47] || (_cache[47] = _createElementVNode("div", { class: "status-indicator status-pending" }, null, -1)),
                                  _createElementVNode("span", _hoisted_133, _toDisplayString(_ctx.$t('tasks.status.PENDING')), 1),
                                  _createElementVNode("span", _hoisted_134, _toDisplayString(tasksByStatus.value.PENDING), 1)
                                ]),
                                (tasksByStatus.value.ON_HOLD > 0)
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 0,
                                      class: "status-item",
                                      onClick: _cache[21] || (_cache[21] = ($event: any) => (switchTab('tasks')))
                                    }, [
                                      _cache[48] || (_cache[48] = _createElementVNode("div", { class: "status-indicator status-on-hold" }, null, -1)),
                                      _createElementVNode("span", _hoisted_135, _toDisplayString(_ctx.$t('tasks.status.ON_HOLD')), 1),
                                      _createElementVNode("span", _hoisted_136, _toDisplayString(tasksByStatus.value.ON_HOLD), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
          ]),
          _createVNode(_Transition, { name: "slide-left" }, {
            default: _withCtx(() => [
              (selectedPhase.value || selectedIntervenant.value || selectedTask.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "details-panel-overlay",
                    onClick: _withModifiers(clearSelection, ["self"])
                  }, [
                    _createElementVNode("div", _hoisted_137, [
                      _createElementVNode("div", _hoisted_138, [
                        _createElementVNode("h3", null, _toDisplayString(_ctx.$t('workspace.details.title')), 1),
                        _createElementVNode("button", {
                          class: "btn-close",
                          onClick: clearSelection,
                          title: _ctx.$t('common.close')
                        }, "✕", 8, _hoisted_139)
                      ]),
                      _createElementVNode("div", _hoisted_140, [
                        (selectedPhase.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_141, [
                              _createElementVNode("h4", null, _toDisplayString(selectedPhase.value.name), 1),
                              _createElementVNode("div", _hoisted_142, [
                                _createElementVNode("div", _hoisted_143, [
                                  _createElementVNode("span", _hoisted_144, _toDisplayString(_ctx.$t('workspace.details.status')), 1),
                                  _createElementVNode("span", {
                                    class: _normalizeClass(`status-badge status-${selectedPhase.value.status?.toLowerCase()}`)
                                  }, _toDisplayString(_ctx.$t(`phases.statusOptions.${selectedPhase.value.status}`)), 3)
                                ]),
                                _createElementVNode("div", _hoisted_145, [
                                  _createElementVNode("span", _hoisted_146, _toDisplayString(_ctx.$t('workspace.details.duration')), 1),
                                  _createElementVNode("span", _hoisted_147, _toDisplayString(_unref(formatDate)(selectedPhase.value.plannedStartDate)) + " - " + _toDisplayString(_unref(formatDate)(selectedPhase.value.plannedEndDate)), 1)
                                ]),
                                (selectedPhase.value.description)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_148, [
                                      _createElementVNode("span", _hoisted_149, _toDisplayString(_ctx.$t('workspace.details.description')), 1),
                                      _createElementVNode("p", _hoisted_150, _toDisplayString(selectedPhase.value.description), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_151, [
                                  _createElementVNode("span", _hoisted_152, _toDisplayString(_ctx.$t('workspace.details.assignedTasks')), 1),
                                  _createElementVNode("div", _hoisted_153, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getTasksForPhase(selectedPhase.value.id!), (task) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: task.id,
                                        class: "task-item-compact"
                                      }, [
                                        _createElementVNode("span", {
                                          class: _normalizeClass(["status-dot", `status-${task.status?.toLowerCase()}`])
                                        }, null, 2),
                                        _createTextVNode(" " + _toDisplayString(task.name), 1)
                                      ]))
                                    }), 128)),
                                    (!getTasksForPhase(selectedPhase.value.id!).length)
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_154, _toDisplayString(_ctx.$t('workspace.details.noTasks')), 1))
                                      : _createCommentVNode("", true)
                                  ])
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (selectedIntervenant.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_155, [
                              _createElementVNode("div", _hoisted_156, [
                                _createElementVNode("div", {
                                  class: "avatar-large",
                                  style: _normalizeStyle({ backgroundColor: _unref(getAvatarColor)(selectedIntervenant.value.name!) })
                                }, _toDisplayString(_unref(getInitials)(selectedIntervenant.value.name!)), 5),
                                _createElementVNode("h4", null, _toDisplayString(selectedIntervenant.value.name), 1)
                              ]),
                              _createElementVNode("div", _hoisted_157, [
                                _createElementVNode("div", _hoisted_158, [
                                  _createElementVNode("span", _hoisted_159, _toDisplayString(_ctx.$t('workspace.details.type')), 1),
                                  _createElementVNode("span", _hoisted_160, _toDisplayString(_ctx.$t(`intervenants.types.${selectedIntervenant.value.type}`)), 1)
                                ]),
                                _createElementVNode("div", _hoisted_161, [
                                  _createElementVNode("span", _hoisted_162, _toDisplayString(_ctx.$t('workspace.details.email')), 1),
                                  _createElementVNode("a", {
                                    class: "detail-value",
                                    href: `mailto:${selectedIntervenant.value.email}`
                                  }, _toDisplayString(selectedIntervenant.value.email), 9, _hoisted_163)
                                ]),
                                _createElementVNode("div", _hoisted_164, [
                                  _createElementVNode("span", _hoisted_165, _toDisplayString(_ctx.$t('workspace.details.phone')), 1),
                                  _createElementVNode("a", {
                                    class: "detail-value",
                                    href: `tel:${selectedIntervenant.value.phone}`
                                  }, _toDisplayString(selectedIntervenant.value.phone), 9, _hoisted_166)
                                ]),
                                (selectedIntervenant.value.address)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_167, [
                                      _createElementVNode("span", _hoisted_168, _toDisplayString(_ctx.$t('workspace.details.address')), 1),
                                      _createElementVNode("p", _hoisted_169, _toDisplayString(selectedIntervenant.value.address), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_170, [
                                  _createElementVNode("span", _hoisted_171, _toDisplayString(_ctx.$t('workspace.details.assignedTasks')), 1),
                                  _createElementVNode("div", _hoisted_172, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getTasksForIntervenant)(selectedIntervenant.value.id!), (task) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: task.id,
                                        class: "task-item-compact"
                                      }, [
                                        _createElementVNode("span", {
                                          class: _normalizeClass(["status-dot", `status-${task.status?.toLowerCase()}`])
                                        }, null, 2),
                                        _createTextVNode(" " + _toDisplayString(task.name) + " - " + _toDisplayString(getFormattedAmount(`task-${task.id}`)), 1)
                                      ]))
                                    }), 128)),
                                    (!_unref(getTasksForIntervenant)(selectedIntervenant.value.id!).length)
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_173, _toDisplayString(_ctx.$t('workspace.details.noTasks')), 1))
                                      : _createCommentVNode("", true)
                                  ])
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (selectedTask.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_174, [
                              _createElementVNode("h4", null, _toDisplayString(selectedTask.value.name), 1),
                              _createElementVNode("div", _hoisted_175, [
                                _createElementVNode("div", _hoisted_176, [
                                  _createElementVNode("span", _hoisted_177, _toDisplayString(_ctx.$t('workspace.details.status')), 1),
                                  _createElementVNode("span", {
                                    class: _normalizeClass(`status-badge status-${selectedTask.value.status?.toLowerCase()}`)
                                  }, _toDisplayString(_ctx.$t(`tasks.status.${selectedTask.value.status}`)), 3)
                                ]),
                                _createElementVNode("div", _hoisted_178, [
                                  _createElementVNode("span", _hoisted_179, _toDisplayString(_ctx.$t('workspace.details.amount')), 1),
                                  _createElementVNode("span", _hoisted_180, _toDisplayString(selectedTask.value?.id ? getFormattedAmount(`task-${selectedTask.value.id}`) : '-'), 1)
                                ]),
                                (selectedTask.value.intervenantName)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_181, [
                                      _createElementVNode("span", _hoisted_182, _toDisplayString(_ctx.$t('workspace.details.intervenant')), 1),
                                      _createElementVNode("span", _hoisted_183, _toDisplayString(selectedTask.value.intervenantName), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (project.value?.multiPhase && selectedTask.value.phaseName)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_184, [
                                      _createElementVNode("span", _hoisted_185, _toDisplayString(_ctx.$t('workspace.details.phase')), 1),
                                      _createElementVNode("span", _hoisted_186, _toDisplayString(selectedTask.value.phaseName), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_187, [
                                  _createElementVNode("span", _hoisted_188, _toDisplayString(_ctx.$t('workspace.details.duration')), 1),
                                  _createElementVNode("span", _hoisted_189, _toDisplayString(_unref(formatDate)(selectedTask.value.startDate)) + " - " + _toDisplayString(_unref(formatDate)(selectedTask.value.endDate)), 1)
                                ]),
                                (selectedTask.value.description)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_190, [
                                      _createElementVNode("span", _hoisted_191, _toDisplayString(_ctx.$t('workspace.details.description')), 1),
                                      _createElementVNode("p", _hoisted_192, _toDisplayString(selectedTask.value.description), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _createVNode(PhaseFormModal, {
          show: showPhaseModal.value,
          phase: editingPhase.value,
          "project-id": _ctx.projectId,
          onClose: closePhaseModal,
          onSaved: handlePhaseSaved
        }, null, 8, ["show", "phase", "project-id"]),
        _createVNode(AssignIntervenantModal, {
          show: showIntervenantModal.value,
          phase: null,
          "project-id": _ctx.projectId,
          "existing-intervenants": intervenants.value,
          onClose: closeIntervenantModal,
          onIntervenantAssigned: handleIntervenantSaved
        }, null, 8, ["show", "project-id", "existing-intervenants"]),
        _createVNode(TaskFormModal, {
          show: showTaskModal.value,
          task: editingTask.value,
          "project-id": _ctx.projectId,
          project: project.value,
          phases: phases.value,
          intervenants: intervenants.value,
          onClose: closeTaskModal,
          onSaved: handleTaskSaved
        }, null, 8, ["show", "task", "project-id", "project", "phases", "intervenants"]),
        (showDeletePhaseConfirm.value)
          ? (_openBlock(), _createBlock(ConfirmModal, {
              key: 0,
              isVisible: showDeletePhaseConfirm.value,
              title: _ctx.$t('phases.deletePhase'),
              message: _ctx.$t('workspace.confirmDelete.phase'),
              details: deletePhaseMessage.value,
              "confirm-text": _ctx.$t('common.delete'),
              "cancel-text": _ctx.$t('common.cancel'),
              type: "danger",
              onConfirm: confirmDeletePhase,
              onCancel: cancelDeletePhase
            }, null, 8, ["isVisible", "title", "message", "details", "confirm-text", "cancel-text"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["project-id"]))
}
}

})